import React from "react";
import cn from "classnames";
import Styles from "./EventScore.module.scss";
import { Text } from "../Text/Text";

interface EventScoreProps {
  score?: string;
  className?: string;
}

export function EventScore({ score, className }: EventScoreProps) {
  const scoreStyle = React.useMemo(() => {
    if (score === undefined) {
      return;
    }
    const startingLetter = score.length > 0 ? score[0] : "";
    switch (startingLetter) {
      case "W":
        return Styles.win;
      case "L":
        return Styles.loss;
      case "T":
        return Styles.tie;
      default:
        return Styles.live;
    }
  }, [score]);

  return (
    <Text className={cn(scoreStyle, className)} weight={"semibold"}>
      {score}
    </Text>
  );
}
